import { Component, OnInit } from '@angular/core';
import {AuthorizationService} from './authorization.service';
import { NewPasswordModel } from './login.model';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-confirm-password',
  providers: [AuthorizationService],
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.less']
})
export class ConfirmPasswordComponent implements OnInit {

  newPasswordModel = new NewPasswordModel();
  showInfo = false;
  showInfoWrong = false;

  constructor(private authorizationService: AuthorizationService, private route: ActivatedRoute, private _router: Router) { }

  ngOnInit() {
    this.route.params
              .subscribe((params: Params) => {
                  this.newPasswordModel.confirmHash = params['hash'];
                }
              );
  }

  resetPassword(form: NgForm, isValid: boolean) {

   this.newPasswordModel.newPassword = form.value.new_password;
   this.newPasswordModel.confirmPassword = form.value.confirm_password;
   console.log(this.newPasswordModel);

   if ( isValid ) {
     this.authorizationService.setNewPassword(this.newPasswordModel)
       .subscribe(
         ((response) => {
           console.log(response);
           this.showInfo = true;
           this.showInfoWrong = false;
           setTimeout(() => {this._router.navigateByUrl('Login'); } , 3000);
         }),
         (error) => {
           if (error < 200 || error >= 300) {
             this.showInfoWrong = true;
           }
         }
       );
   }

  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/authorization/confirm-password.component.ts